import React, {useCallback, useEffect, useState} from 'react';
import logo from '../../images/ic-ionev-1953px-2044px.png';
import NavigationLinks from './NavigationLinks';
import GroupsDropdown from './GroupsDropdown';
import { Link } from "react-router-dom";
import DateSelectors from "./DateSelectors";


function Header (props) {
    const [tempSelectedGroups, setTempSelectedGroups] = useState([]);
    const [tempUtcStartDate, setTempUtcStartDate] = useState(null);
    const [tempUtcEndDate, setTempUtcEndDate] = useState(null);

    var activeLink = props.activeLink;
    var disableSelector = props.loading;
    const {selectedGroups, startDate, endDate, groups} = props;

    if(activeLink === "tco-metrics"){
      activeLink = "vcl-metrics";
      disableSelector = true;
    }

    let headerText = props.fleetName;
    if (props.apiError) headerText = "Error";
    else if (props.loading) headerText="Loading";

    useEffect(() => {
      setTempSelectedGroups(selectedGroups);
      //TCO comparison page nulls out dates so we want to make sure we don't set date pickers to null if updating groups on that page
      if(startDate) setTempUtcStartDate(startDate);
      if(endDate) setTempUtcEndDate(endDate);
    },[selectedGroups, startDate, endDate])

  const handleControlChange = useCallback((accessor, value) => {
    if(accessor === 'startDate') {
      setTempUtcStartDate(value);
    } else if (accessor === 'endDate') {
      setTempUtcEndDate(value);
    } else if (accessor === 'selectedGroups') {
      if(value.length > 0 && value[0].value === 'all_groups') {
        setTempSelectedGroups(groups);
      } else {
        setTempSelectedGroups(value);
      }
    } else {
      return;
    }
  },[groups])

    function groupsMatch(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      return arr1.every((value, index) => (
        value.value === arr2[index]?.value && value.label === arr2[index]?.label
      ))
    }

    function datesMatch(date1, date2) {
      if(date1?.ts && date2?.ts && date1.ts === date2.ts) {
        return true;
      } else {
        return false;
      }
    }
    return (
      <div className="swt-ionev-header">
        <Link to="/ionev">
          <img src={logo} className="ionev-logo" alt="ionEV logo" />
        </Link>
        <Link className="ionev-header-text-link" to="/ionev">
          <h1 className="ionev-header-text ionev-h1">{headerText}</h1>
        </Link>
       {!props.loading &&
        <div className="ionev-header-navigation">
          <NavigationLinks
              activeLink={activeLink}
              user={props.user}
          />
          <div className='ionev-header-controls-container'>
            <div>
              <p className="ionev-header-controls-label">Groups</p>
              <GroupsDropdown
                ClearSelectedIcon={null}
                onChange={(e) => handleControlChange('selectedGroups', e)}
                value={tempSelectedGroups}
                options={props.groups}
              />
            </div>
          <div>
            <p className="ionev-header-controls-label">Select Period</p>
            <DateSelectors 
              startDate={props.startDate}
              endDate={props.endDate}
              minDate={props.fleetStartDate}
              maxDate={props.fleetEndDate}
              handleChange={handleControlChange}
              disabled={disableSelector}
              userSettings={props.userSettings} 
            />
          </div>
          <div>
          <button className='ionev-header-update-button' disabled={groupsMatch(tempSelectedGroups, selectedGroups) && datesMatch(tempUtcStartDate, startDate) && datesMatch(tempUtcEndDate, endDate) ? true : false} onClick={() => props.handleSubmit(tempSelectedGroups, tempUtcStartDate, tempUtcEndDate)}>Update</button>
          </div>
          </div>
        </div>
      }
      </div>
    );
}

export default Header;